"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSellerVendorDto = instanceOfSellerVendorDto;
exports.SellerVendorDtoFromJSON = SellerVendorDtoFromJSON;
exports.SellerVendorDtoFromJSONTyped = SellerVendorDtoFromJSONTyped;
exports.SellerVendorDtoToJSON = SellerVendorDtoToJSON;
exports.SellerVendorDtoToJSONTyped = SellerVendorDtoToJSONTyped;
/**
 * Check if a given object implements the SellerVendorDto interface.
 */
function instanceOfSellerVendorDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('isVerified' in value) || value['isVerified'] === undefined)
        return false;
    return true;
}
function SellerVendorDtoFromJSON(json) {
    return SellerVendorDtoFromJSONTyped(json, false);
}
function SellerVendorDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'image': json['image'] == null ? undefined : json['image'],
        'email': json['email'],
        'countryCode': json['countryCode'] == null ? undefined : json['countryCode'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'isVerified': json['isVerified'],
    };
}
function SellerVendorDtoToJSON(json) {
    return SellerVendorDtoToJSONTyped(json, false);
}
function SellerVendorDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'image': value['image'],
        'email': value['email'],
        'countryCode': value['countryCode'],
        'phone': value['phone'],
        'isVerified': value['isVerified'],
    };
}
